import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { useAuctionsStore } from 'components/pages/campaign-settings/campaign-auction/auction-router/useAuctionsStore';
import { IntercomProductTourTargets } from 'constants/intercom';
import { AUCTIONS_LEARN_MORE_LINK } from 'constants/links';
import { posthogEvents } from 'constants/posthog-events';
import { usePosthog } from 'customHooks/usePosthog';

const GetStarted = () => {
    const setShowGettingStarted = useAuctionsStore(state => state.setShowGettingStarted);
    const { pushEvent } = usePosthog();

    const handleAddAuction = () => {
        pushEvent(posthogEvents.AUCTION_CREATE_STARTED);
        setShowGettingStarted(false);
    };

    return (
        <Box className={'grid grid-cols-2'}>
            <div className={'col-span-full pb-16 pl-12 pr-12 pt-16 lg:col-span-1'}>
                <h2 className={'text-[42px] font-medium leading-[52px]'}>
                    Take your auction to a whole{' '}
                    <span
                        className={
                            'relative after:absolute after:bottom-0.5 after:left-0 after:right-0 after:-z-[1] after:h-2 after:bg-yellow-100'
                        }
                    >
                        new level
                    </span>
                    !
                </h2>
                <p className={'mt-6 text-base'}>
                    Run your dream fundraising event with a seamless auction experience that is fun
                    and easy for you and your supporters.{' '}
                    <a target={'_blank'} rel={'noreferrer'} href={AUCTIONS_LEARN_MORE_LINK}>
                        Learn More
                    </a>
                </p>
                <Button
                    variant="solid"
                    data-intercom-target={IntercomProductTourTargets.AuctionGettingStartedButton}
                    className={'mt-10'}
                    onClick={handleAddAuction}
                >
                    Add Auction
                </Button>
            </div>
            <div className={'relative col-span-full lg:col-span-1'}>
                <img
                    className={'bottom-0 left-0 right-0 lg:absolute'}
                    alt="Auction splash"
                    src={`/images/illustrations/auction-splash.png`}
                />
            </div>
        </Box>
    );
};

export { GetStarted };
